var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5749 3.81034L1.51656 15.5937C1.37104 15.8457 1.29403 16.1314 1.29322 16.4224C1.2924 16.7135 1.3678 16.9996 1.51192 17.2524C1.65603 17.5053 1.86383 17.716 2.11465 17.8636C2.36547 18.0111 2.65056 18.0905 2.94156 18.0937H17.0582C17.3492 18.0905 17.6343 18.0111 17.8851 17.8636C18.136 17.716 18.3438 17.5053 18.4879 17.2524C18.632 16.9996 18.7074 16.7135 18.7066 16.4224C18.7058 16.1314 18.6288 15.8457 18.4832 15.5937L11.4249 3.81034C11.2763 3.56543 11.0672 3.36294 10.8176 3.22241C10.568 3.08188 10.2863 3.00806 9.9999 3.00806C9.71345 3.00806 9.43184 3.08188 9.18223 3.22241C8.93263 3.36294 8.72345 3.56543 8.5749 3.81034Z",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8.09375V11.4271",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.7605H10.0083",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.70c1b300549868242693f8081095d5d7.svg";
export { ForwardRef as ReactComponent };